module.exports = __webpack_public_path__ + "static/img/17introduce.e7c0dbfb.jpg";